var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.background),attrs:{"id":"app"}},[_c('about'),_c('technologies'),_c('projects'),_c('guestbook'),_c('iconCredits')],1)}
var staticRenderFns = []

export { render, staticRenderFns }